import './WhatsNew.css'
import { format, parseISO } from 'date-fns'
import { useTranslation } from 'react-i18next'
import Modal, { ModalStateProps } from '../../ui/Modal'
import Markdown from '../chat/Markdown'
import { ReleaseNote } from './releaseNotes'

interface WhatsNewProps extends ModalStateProps {
    notes: ReleaseNote[]
}

const formatDate = (date: string) => {
    if (!date) return ''
    try {
        return format(parseISO(date), 'MMMM d, yyyy')
    } catch {
        return date
    }
}

export default function WhatsNew({ open, onClose, notes }: WhatsNewProps) {
    const { t } = useTranslation()
    return (
        <Modal open={open} onClose={onClose} title={t('whats_new')} size="large">
            <div className="whats-new">
                {notes.length === 0
                    ? <p className="whats-new-empty">{t('whats_new_empty')}</p>
                    : notes.map((note) => (
                        <section className="whats-new-release" key={note.version}>
                            <div className="whats-new-release-header">
                                <h3>{`v${note.version}`}</h3>
                                {note.date && <span className="whats-new-date">{formatDate(note.date)}</span>}
                            </div>
                            <div className="whats-new-body">
                                <Markdown text={note.body} />
                            </div>
                        </section>
                    ))}
            </div>
        </Modal>
    )
}
